<template>
  <div class="content">
    <div class="container">
      <div v-if="loading">
        <div id="loader">
          <font-awesome-icon icon="spinner" spin />
        </div>
      </div>
    </div>

    <b-breadcrumb>
      <b-breadcrumb-item :to="{ path: '/dashboard' }">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Nueva Copia Certificada</b-breadcrumb-item>
    </b-breadcrumb>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog-route" hide-footer id="modal-confirm-dialog-route">
      <h4 class="text-center">¿Seguro que quiere salir de la página?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog-route')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="beforeLeave(true)">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
      <h4 class="text-center">¿Seguro que quiere salir sin guardar los cambios?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-cotizacion" hide-footer id="modal-confirm-cotizacion">
      <h4 class="text-center">¿Seguro que quiere continuar al pago?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-cotizacion')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="generaObjetosBD()">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop id="modal-help-cotejos-1" size="xl" centered hide-footer>
      <div>
        <b-carousel id="carousel-cotejos-1" :interval="0" controls indicators background="#ababab">
          <b-carousel-slide :img-src="require('@/assets/img/cotejos/help/2_1.webp')"></b-carousel-slide>
          <b-carousel-slide :img-src="require('@/assets/img/cotejos/help/2_2.webp')"></b-carousel-slide>
          <b-carousel-slide :img-src="require('@/assets/img/cotejos/help/2_3.webp')"></b-carousel-slide>
        </b-carousel>
      </div>
    </b-modal>
    <b-modal no-close-on-backdrop id="modal-help-cotejos-3" size="xl" centered hide-footer>
      <div>
        <b-carousel id="carousel-cotejos-1" :interval="0" controls indicators background="#ababab">
          <b-carousel-slide :img-src="require('@/assets/img/cotejos/help/2_4.webp')"></b-carousel-slide>
        </b-carousel>
      </div>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-datos-existentes" hide-footer size="md">
      <h4 class="text-center">Actualmente existe información llenada previamente, ¿Desea continuar con los mismos datos?</h4>
      <b-button class="mt-3" variant="danger" @click="cleanPreviousInfo">No, limpiar la información.</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="hideModalDatosExistentes">
        Continuar con la información previa.
      </b-button>
    </b-modal>

    <div class="container-fluid">
      <b-row>
        <b-col class="col-3">
          <b-card>
            <TreeCotejo
              :cotejo="cotejoStore.cotejo"
              :user="'Client'"
              :selected-component="cotejoStore.currentComponentBody"
              @node="selected"
            />
          </b-card>
          <div>
            <b-img
              v-if="cotejoStore.currentComponentBody === 'Solicitantes'"
              :src="require('@/assets/img/cotejos/help/1.webp')"
              fluid-grow
              alt="Descripción del solicitante"
            ></b-img>
            <b-img
              v-if="cotejoStore.currentComponentBody === 'DomicilioEntregaOriginales'"
              :src="require('@/assets/img/cotejos/help/5.webp')"
              fluid-grow
              alt="Descripción del domicilio de entrega"
            ></b-img>
            <b-img
              v-if="cotejoStore.currentComponentBody === 'Documentos'"
              :src="require('@/assets/img/cotejos/help/2.webp')"
              fluid-grow
              alt="Descripción de los documentos"
            ></b-img>
            <b-button
              v-if="cotejoStore.currentComponentBody === 'Documentos'"
              class="orange-btn"
              block
              @click="$bvModal.show('modal-help-cotejos-1')"
            >
              Más información
            </b-button>
            <b-img
              v-if="cotejoStore.currentComponentBody === 'Cotizacion'"
              :src="require('@/assets/img/cotejos/help/3.webp')"
              fluid-grow
              alt="Descripción de la cotización"
            ></b-img>
          </div>
        </b-col>
        <b-col class="col-9">
          <b-card>
            <b-row>
              <b-col class="col-12">
                <div v-if="cotejoStore.currentComponentBody === 'Solicitantes'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form
                      ref="solicitantes"
                      @submit.prevent="handleSubmit(changeCurrentComponentBody('DomicilioEntregaOriginales'))"
                    >
                      <Solicitantes :cotejo="cotejoStore.cotejo" @submit.prevent @allChecksPassed="submitForm('solicitantes')" />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="cotejoStore.currentComponentBody === 'DomicilioEntregaOriginales'">
                  <DomicilioEntregaOriginales
                    :cotejo="cotejoStore.cotejo"
                    @submit.prevent
                    @allChecksPassed="submitForm('DomicilioEntregaOriginales')"
                  />
                </div>
                <div v-if="cotejoStore.currentComponentBody === 'Documentos'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form ref="documentos" @submit.prevent="handleSubmit(changeCurrentComponentBody('Cotizacion'))">
                      <Documentos
                        :cotejo="cotejoStore.cotejo"
                        @submit.prevent
                        @allChecksPassed="submitForm('documentos')"
                        @toggleOnLoadingEvent="toggleOnLoadingHandler"
                        @toggleOffLoadingEvent="toggleOffLoadingHandler"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="cotejoStore.currentComponentBody === 'Cotizacion'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form ref="cotizacion" @submit.prevent="handleSubmit(showCotizacionModal())">
                      <Cotizacion
                        :cotejo="cotejoStore.cotejo"
                        @submit.prevent
                        @allChecksPassed="submitForm('cotizacion')"
                        @toggleOnLoadingEvent="toggleOnLoadingHandler"
                        @toggleOffLoadingEvent="toggleOffLoadingHandler"
                      />
                    </form>
                  </ValidationObserver>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import TreeCotejo from "@/views/clients/procesos/cotejo/TreeCotejo.vue";
import Cotizacion from "@/views/clients/procesos/cotejo/infoBase/Cotizacion.vue";
import Documentos from "@/views/clients/procesos/cotejo/infoBase/Documentos.vue";
import Solicitantes from "@/views/clients/procesos/cotejo/infoBase/Solicitante.vue";
import DomicilioEntregaOriginales from "@/views/clients/procesos/cotejo/infoBase/DomicilioEntregaOriginales.vue";

import { ClientesApi, ComparecientesApi, CotejosApi, CotizacionesApi, DocumentosApi, DocumentosXServiciosApi } from "@/api";
import loadingMixin from "@/mixins/loadingMixin";
import Storage from "@/utils/storage";
import { useCotejoStore } from "@/stores";

const storage = new Storage();

export default {
  name: "AddCotejo",

  components: {
    TreeCotejo,
    Solicitantes,
    Documentos,
    Cotizacion,
    DomicilioEntregaOriginales,
  },

  mixins: [loadingMixin],

  setup() {
    const cotejoStore = useCotejoStore();

    return { cotejoStore };
  },

  mounted() {
    if (this.cotejoStore.cotejo.solicitantes.length > 0) {
      this.showModalDatosExistentes();
      return;
    }

    this.cotejoStore.initCotejoStore();
  },

  beforeRouteLeave(to, from, next) {
    if (to.name !== "EditCotejo") {
      this.next = next;
      this.$refs["modal-confirm-dialog-route"].show();
    } else {
      // Initialize store before leaving to EditCotejo
      this.cotejoStore.initCotejoStore();
      next();
    }
  },

  data: () => ({
    next: null,
    prenode: null,

    cliente_id: 0,

    cotejo_id: null,
    comparecientes: [],
  }),

  methods: {
    showModalDatosExistentes() {
      this.$refs["modal-datos-existentes"].show();
    },

    hideModalDatosExistentes() {
      this.$refs["modal-datos-existentes"].hide();
    },

    cleanPreviousInfo() {
      this.cotejoStore.initCotejoStore();
      this.hideModalDatosExistentes();
      // this.$router.go(0);
    },

    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000, //false,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    // Navegación
    beforeLeave(answer) {
      if (answer) {
        // Initialize store before leaving the route
        this.cotejoStore.initCotejoStore();
        this.next();
      }
    },

    selected(node) {
      const componentValues = this.cotejoStore.cotejo.currentComponentValues;
      const keys = Object.keys(componentValues);
      const values = Object.values(componentValues);
      const destIndex = keys.findIndex((key) => key === node);

      if (destIndex === -1) return;

      const currentIndex = keys.findIndex((key) => key === this.cotejoStore.currentComponentBody);
      const lastCompletedIndex = values.lastIndexOf(true);
      const isMovingForward = destIndex > currentIndex;
      const isTargetCompleted = Boolean(componentValues[node]);

      if (!isMovingForward) {
        this.cotejoStore.currentComponentBody = node;
        return;
      }

      if (isTargetCompleted) {
        this.cotejoStore.currentComponentBody = node;
        return;
      }

      const isNextAfterLastCompleted = destIndex === lastCompletedIndex + 1;
      if (isNextAfterLastCompleted) {
        this.cotejoStore.currentComponentBody = node;
        return;
      }

      this.$toast.warning("Completa la sección previa para poder continuar", {
        timeout: 3000,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    changeCurrentComponentBody(body) {
      this.cotejoStore.cotejo.currentComponentValues[this.cotejoStore.currentComponentBody] = true;
      this.cotejoStore.currentComponentBody = body;
    },

    submitForm(formToSubmit) {
      if (formToSubmit === "DomicilioEntregaOriginales") {
        this.changeCurrentComponentBody("Documentos");
        return;
      }

      const form = this.$refs[formToSubmit];
      const event = new Event("submit", { bubbles: true, cancelable: true });
      form.dispatchEvent(event);
    },

    showCotizacionModal() {
      this.$refs["modal-confirm-cotizacion"].show();
    },

    hideCotizacionModal() {
      this.$refs["modal-confirm-cotizacion"].hide();
    },

    generaObjetosBD() {
      this.loading = true;

      this.hideCotizacionModal();

      this.getClienteId()
        .then(() => this.fillComparecientes())
        .then(() => this.postCotejo())
        .then(() => this.modifyCotizacion())
        .then(() => this.addDocumentos())
        .then(() => this.addAnexos())
        .then(() => {
          // Initialize store before navigation to ensure clean state
          this.cotejoStore.initCotejoStore();
          this.moveToEditCotejos();
        })
        .catch((error) => {
          console.log(error);
          this.showErrorToast("No se pudieron obtener los datos. Intente más tarde.");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async getClienteId() {
      const clienteEmail = storage.getItem("user");
      const { id } = await ClientesApi.clienteId(clienteEmail);
      this.cliente_id = id;
    },

    fillComparecientes() {
      if (this.cotejoStore.cotejo.solicitantes[0].id) {
        this.cotejoStore.cotejo.id_comparecientes = this.cotejoStore.cotejo.solicitantes[0].id;
      } else {
        this.cotejoStore.cotejo.id_comparecientes = null;
      }
    },

    processComparecientes(comparecientes) {
      // console.log(comparecientes);
      for (let i = 0; i < comparecientes.length; i++) {
        let compareciente = comparecientes[i];

        if (!("cliente_id" in compareciente)) {
          const index = this.cotejoStore.cotejo.solicitantes.indexOf(compareciente);
          if (index !== -1) {
            this.cotejoStore.cotejo.solicitantes[index] = this.postCompareciente(compareciente);
          }
        }
      }
    },

    postCompareciente(compareciente) {
      const personaMoral = this.cotejoStore.cotejo.solicitantes.find((item) => item.persona === "Moral");
      const idMoral = personaMoral ? personaMoral.id : null;
      const tipo_validacion = compareciente.persona == "Moral" ? "new_constitucion_pm" : "new_constitucion_pf";
      const moral_representada_id = compareciente.persona == "Física" ? idMoral : null;

      compareciente.cliente_id = this.cliente_id;
      compareciente.tipo_validacion = tipo_validacion;
      compareciente.moral_representada_id = moral_representada_id;

      return compareciente;
    },

    async postCotejo() {
      let solicitante = null;

      if (!this.cotejoStore.cotejo.solicitantes[0].id) {
        solicitante = this.cotejoStore.cotejo.solicitantes[0];
      }

      const cotizacion = this.cotejoStore.cotejo.cotizacion;

      const createdCotejo = await CotejosApi.create({
        id_prioridad: this.cotejoStore.cotejo.id_prioridad,
        id_clientes: this.cliente_id,
        id_comparecientes: this.cotejoStore.cotejo.id_comparecientes || 0,
        pago_complementario: null,
        envio_domicilio: this.cotejoStore.cotejo.envio_domicilio,
        corredurias_id: 17,
        solicitante: solicitante,
        clausulas_confirmacion: this.cotejoStore.cotejo.clausulas_confirmacion,
        domicilio_entrega_originales: this.cotejoStore.cotejo.domicilio_entrega_originales,
        referencia: this.cotejoStore.cotejo.referencia,
      });

      Object.assign(this.cotejoStore.cotejo, createdCotejo);

      this.cotejoStore.cotejo.cotizacion = cotizacion;
      this.cotejo_id = this.cotejoStore.cotejo.id;
    },

    async modifyCotizacion() {
      const payload = {
        precio_total: this.cotejoStore.cotejo.costo_total,
        activo: 1,
        conceptos: this.cotejoStore.cotejo.cotizacion?.conceptos || {},
      };

      if (this.cotejoStore.cotejo.cotizacion?.cupones_id) {
        payload.cupones_id = this.cotejoStore.cotejo.cotizacion.cupones_id;
      }

      await CotizacionesApi.edit(this.cotejoStore.cotejo.id_cotizaciones, payload);
    },

    async addDocumentos() {
      const docsPrincipales = this.cotejoStore.cotejo.documentos.filter((doc) => !("anexoDe" in doc));

      const principalPromises = docsPrincipales.map(async (documento) => {
        const documento_id = await this.postDocumento({
          cat_documentos_id: documento.catDocumentos_id,
          paginas: parseInt(documento.paginas),
          nombre: documento.nombre,
          copias_certificadas: parseInt(documento.copias_certificadas),
        });
        documento.documento_id = documento_id;
      });

      const additionalPromises = [
        // this.postDocumento({ cat_documentos_id: 75, nombre: "Carta Responsiva" }),
        // this.postDocumento({ cat_documentos_id: 76, nombre: "Acta PDF" }),
        this.postDocumento({ cat_documentos_id: 129, nombre: "KYC" }),
      ];

      await Promise.all([...principalPromises, ...additionalPromises]);
    },

    async addAnexos() {
      const docsWithAnexo = this.cotejoStore.cotejo.documentos.filter((doc) => "tiene_anexo" in doc && doc.tiene_anexo);

      const promises = docsWithAnexo.map(async (documento) => {
        const documento_id = await this.postDocumento({
          cat_documentos_id: 73,
          auto_referencia: documento.documento_id,
          paginas: parseInt(documento.paginas_anexo),
          nombre: `Anexo de ${documento.tipo}`,
        });
        documento.documento_id = documento_id;
      });

      await Promise.all(promises);
    },

    async postDocumento({
      cat_documentos_id,
      auto_referencia = null,
      descripcion = null,
      paginas = null,
      nombre = null,
      copias_certificadas = null,
    }) {
      const { id } = await DocumentosApi.create({
        documento: "",
        cat_documentos_id,
        auto_referencia,
        descripcion,
        paginas,
        copias_certificadas,
        nombre,
      });
      await DocumentosXServiciosApi.create({
        documentos_id: id,
        cat_servicios_id: 4,
        proceso_id: this.cotejoStore.cotejo.id,
      });
      return id;
    },

    moveToEditCotejos() {
      this.$router.push({
        name: "EditCotejo",
        params: { id: this.cotejo_id },
      });
    },
  },
};
</script>
